import { isSemTraffic } from "@faire/retailer-visitor-shared/lib/navigation-origin/isComingFromSEM";
import { useIsLoggedOutDiscoverPage } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { useSearchParams } from "next/navigation";
import { useMemo } from "react";

/**
 * @name useIsSemDiscoverPage
 * @description Determines if user is a paid user
 * and if the current page is the logged out discover page.
 *
 * @note medium=cpc is the query parameter that is
 * used to determine if the user is a paid user.
 * We also need to determine if the user is on the discover page.
 */
export const useIsSemDiscoverPage = (): boolean => {
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
  const searchParams = useSearchParams();
  const searchParamsObject = Object.fromEntries(searchParams?.entries() ?? []);

  return useMemo(
    () => isSemTraffic(searchParamsObject) && isLoggedOutDiscoverPage,
    [isLoggedOutDiscoverPage, searchParamsObject]
  );
};
